import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/App.css";
import SideBar from "../sidebar/SideBar";
import classNames from "classnames";
import { Container } from "react-bootstrap";
import NavBar from "../content/NavBar";
import Footer from "./Footer";
import { useDispatch } from 'react-redux';
import { setIsSideMenuOpen } from '../../stores/modules/idp/authreducer'
import { useLocation } from "react-router-dom";
const MainLayoutPage = ({ children }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true);
  // const [isMobile, setIsMobile] = useState(true);
  const previousWidthRef = React.useRef(-1);
  const location = useLocation();

  const updateWidth = () => {
    const width = window.innerWidth;
    const widthLimit = 576;
    const newIsMobile = width <= widthLimit;
    const wasMobile = previousWidthRef.current <= widthLimit;

    if (newIsMobile !== wasMobile) {
      setIsOpen(!newIsMobile);
    }

    previousWidthRef.current = width;
  };

  useEffect(() => {
    updateWidth();

    window.addEventListener("resize", updateWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.search,location.pathname]);

  const toggle = () => {
    setIsOpen(!isOpen);
    dispatch(setIsSideMenuOpen(!isOpen));
  };

  return (
    <div className="App wrapper">
      <SideBar toggle={toggle} isOpen={isOpen} />
     <Container fluid  className={classNames("content", { "is-open": isOpen })} style={{ width: isOpen ? '84%' : '100%' }} >
      <NavBar toggle={toggle} />
      <main  className="main">{children}</main>
      <Footer/>
    </Container>
    </div>
  );
};

export default MainLayoutPage;
